import { queryOptions } from '@tanstack/react-query';
import { Domain } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const unavailabilityDayKeys = {
    all: ['unavailabilityDays'],
    get: (filter, scope) => ['unavailabilityDays', filter, scope],
};
export const unavailabilityDayOptions = {
    get: (filter, scope) => queryOptions({
        queryKey: unavailabilityDayKeys.get(filter, scope),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.UnavailabilityDay);
            return repo.get(filter, scope);
        },
    }),
};
